import React, { useEffect } from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import { Badge, Tabs, Input, Modal, Descriptions, Button, Form } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_system } from "../../Redux/actions";
import ListSystem from "./listSystem";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UploadList from "./UploadList";
import { error, warning } from "../../Controllers/toast";
import { gql, useMutation } from "@apollo/client";
import QrReaderComponent from "./QRCodeCamera";

const { TabPane } = Tabs;
// const { confirm } = Modal;
const CHECK_GATEWAY = gql`
  mutation CheckGateWayInput(
    $serial_number: String!
    $batch_number: String!
  ) {
    CheckGatewayDevicesStatus(
      serial_number: $serial_number
      batch_number: $batch_number
    ) {
      Gateway_id
      serial_number
      status
    }
  }
`;

const ChoiceSystem = (props) => {
  // Redux Start
  const lang_choiced = useSelector((state) => state.lang_change);
  const new_system = useSelector((state) => state.add_system);

  const dispatch = useDispatch();
  //   Readux end

  const [listData, setListData] = useState();
  const [serialNumber, setSerialNumber] = useState();
  const [batchNumber, setBatchNumber] = useState();
  const [visible, setVisible] = useState(false);

  const [checkGateway] = useMutation(
    CHECK_GATEWAY,
    {
      onCompleted: (data) => {
        if (
          data.CheckGatewayDevicesStatus.serial_number &&
          data.CheckGatewayDevicesStatus.Gateway_id
        ) {
          setListData({ ...data.CheckGatewayDevicesStatus });
          showModal();
        } else {
          error(lang_choiced.pages.add_fact.rules.errorDeviceNotFound);
        }
      },
      onError: (err) => {
        // console.log(err.message);
        error(err.message);
      },
    }
  );




  const handleError = (err) => {
    console.error(err);
  };

  const { Search } = Input;

  // console.log(new_system);
  const notify_success = (value) =>
    toast.success(`${value} ${lang_choiced.pages.add_fact.rules.successAddDevice}`);
  // const notify_danger = () => toast.warn("دستگاه با موفقیت حذف شد!");

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = (e) => {
    setVisible(false);
    notify_success(listData.serial_number);
    dispatch(add_system(listData));

    // props.data(listData)
  };

  const handleCancel = (e) => {
    setVisible(false);
  };
  const Check = async ({ serial_number, batch_number }) => {
    console.log(serial_number, batch_number)
    var check = new_system.findIndex(
      (system) => system.serial_number === serial_number
    );
    if (check >= 0) {
      error(lang_choiced.pages.add_fact.rules.errorDeviceRepeatedly);
    } else {
      checkGateway({ variables: { serial_number, batch_number } });
    }
  };

  const checkStatus = (status) => {
    switch (status) {
      case "active":
        return {
          bool: true,
          component: <Badge status="error" text={lang_choiced.pages.add_fact.badges.active} />,
        };
      case "deactive":
        return {
          bool: false,
          component: <Badge status="success" text={lang_choiced.pages.add_fact.badges.deactive} />,
        };
      default:
        return true;
    }
  };

  return (
    <div>
      {/* <ToastContainer rtl={true} /> */}
      <Modal
        title={lang_choiced.pages.add_system.title}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: checkStatus(listData?.status).bool }}
        okText={lang_choiced.pages.add_system.Modal.btnAdd}
        cancelText={lang_choiced.pages.add_system.Modal.btnCancel}
      >
        <Descriptions title={lang_choiced.pages.add_system.Modal.unit_info} layout="vertical" bordered>
          <Descriptions.Item label={lang_choiced.pages.add_system.Modal.serial_number} span={3}>
            {visible === true ? listData.serial_number : ""}
          </Descriptions.Item>
          <Descriptions.Item label={lang_choiced.pages.add_system.Modal.unit_status} span={3}>
            {checkStatus(listData?.status).component}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
      <Card>
        <CardHeader>{lang_choiced.pages.add_system.title}</CardHeader>
        <CardBody>
          <Tabs defaultActiveKey="2" type="card" size={"large"}>
            <TabPane tab={lang_choiced.pages.add_system.tabs.scanSerial.title} key="1">
              <QrReaderComponent
                handleError={handleError}
                Check={(data) => Check(data)}
              />
            </TabPane>
            <TabPane tab={lang_choiced.pages.add_system.tabs.enterSerial.title} key="2">
              <Form
                layout="vertical"
                onFinish={({ serial_number, batch_number }) => {
                  // console.log(serial_number,batch_number)
                  if (serial_number !== "" && batch_number !== "") {
                    Check({ serial_number, batch_number });
                  } else {
                    warning(lang_choiced.pages.add_system.Modal.warnFillInput);
                  }
                }}
              >
                <Form.Item name="serial_number" label={lang_choiced.pages.add_system.tabs.enterSerial.serialNumberText}>
                  <Input onChange={e => setSerialNumber(e.target.value)} />
                </Form.Item>
                <Form.Item name="batch_number" label={lang_choiced.pages.add_system.tabs.enterSerial.batchNumberText}>
                  <Input onChange={e => setBatchNumber(e.target.value)} />
                </Form.Item>
                <Form.Item>
                  <Button disabled={(!serialNumber || !batchNumber) ? true : false} htmlType="submit">{lang_choiced.pages.add_system.tabs.enterSerial.btnReview}</Button>
                </Form.Item>
              </Form>
            </TabPane>
            <TabPane disabled tab={lang_choiced.pages.add_system.tabs.fileUpload.title} key="3">
              <UploadList />
            </TabPane>
          </Tabs>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>{lang_choiced.pages.add_system.devices_list.title}</CardHeader>
        <CardBody>
          <ListSystem />
        </CardBody>
      </Card>
    </div>
  );
};

export default ChoiceSystem;
